import { useEffect, useRef } from 'react';
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ToastProvider, View } from '@pufferfinance/puffer-ui-components';
import { config } from './wagmi'
import { USDCBalance, USDCBalanceRef } from './components/USDCBalance'
import { DemoCards } from './components/DemoCards'
import './styles/globals.scss';
import styles from './App.module.scss';

const queryClient = new QueryClient()

function App() {
  const usdcBalanceRef = useRef<USDCBalanceRef>(null);

  // Report height to parent window for iframe auto-resize
  useEffect(() => {
    if (window.parent === window) return;

    const postHeight = () => {
      const height = document.documentElement.scrollHeight;
      window.parent.postMessage({ type: 'ap2-resize', height }, '*');
    };

    const observer = new ResizeObserver(postHeight);
    observer.observe(document.documentElement);
    postHeight();

    return () => observer.disconnect();
  }, []);

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <View flexDirection="column" className={styles.app}>
            <View flexDirection="column" className={styles.container}>
              <USDCBalance ref={usdcBalanceRef} />
              <DemoCards
                onBalanceRefresh={() => usdcBalanceRef.current?.refreshBalance()}
              />
            </View>
          </View>
        </ToastProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
